import BaseService from "./BaseService";
import * as apiroutes from "../apiRoutes";

class DashboardService extends BaseService {
  constructor() {
    super(apiroutes.DASHBOARD);
  }

  async get(params = {}) {
    return await super.customCall("GET", "", null, params, null);
  }

  async getMostActiveTopics(params = {}) {
    return await super.customCall(
      "GET",
      "/stats/most-active-topics",
      null,
      params,
      null
    );
  }

  async getTopContributors(params = {}) {
    return await super.customCall(
      "GET",
      "/stats/top-contributors",
      null,
      params,
      null
    );
  }

  async getCategoryWiseTopicCount(params = {}) {
    return await super.customCall(
      "GET",
      "/stats/category-wise-topic-count",
      null,
      params,
      null
    );
  }
}

const DashboardServices = new DashboardService();
export default DashboardServices;
